// import Cookie from 'js-cookie'
export default {
  state: {
    token: '',
    user: ''
  },
  mutations: {},
  actions: {}
}
